import styled from "styled-components";

export const Container = styled.div`
${({ type }) => type!=="resource" && 
  `@media (max-width: 992px) {
    &:last-child {
      display: none;
    }
  }`
}
`

export const CardContainer = styled.div`
  * {
    margin: 0;
    padding: 0;
  }
  ${({ theme }) =>
  `
    font-family: ${theme.font.primary};
  `}
  display: flex;
  flex-direction: column;
  padding: 24px;
  background: #FFFFFF;
  border: 1px solid #E4E7EC;
  ${({ border }) =>
    border &&
  `
    border: 1px solid ${border};
  `}
  border: 1px solid #E4E7EC;
  border-radius: 9px;
  min-height: 480px;
  height: 100%;
  transition: box-shadow 300ms ease;
  &:hover {
    box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
  }
  @media (max-width: 1080px) {
    min-height: 520px;
  }
  @media (max-width: 768px) {
    min-height: 360px;
  }
  .img-wrapper {
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 140px;
    width: 100%;
    object-fit: cover;
    border-radius: 6px;
    margin-bottom: 16px;
    .gatsby-image-wrapper {
      object-position: center;
      width: 100%;
      min-height: 140px;
      border-radius: 6px;
    }
    img {
      object-position: center;
      width: 100%;
      min-height: 140px;
      border-radius: 6px;
    }
  }
  .text-link {
    ${({ theme }) =>
    `
      padding-top: 12px;
      color: ${theme.colors.primary};
      font-weight: bold !important;
    `}
  }

  .card--read-time {
    font-size: 12px;
    color: #222222;
  }
  .line-clamp-2 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
`
